export const lifeQuotes = [
  {
    text: "Communication, empathy and a will to understand, solves a lot of problems, fixes hearts",
    date: "14-12-2021",
    by: "Shamlin",
    desc: "Just my random thought when I saw problems when I got admitted at the hospital for dengue treatment...",
  },
  {
    text: "The purpose of our lives is to be happy.",
    date: "12-01-2022",
    by: "Dilli",
    desc: "Met him when I cycled to Akkarai beach",
  },
];
